import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {interval, merge, Observable, Subject, Subscription} from "rxjs";
import {MarkerType} from "../../maps-component/map/map.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {first, map, startWith, switchMap, take} from "rxjs/operators";
import {GeoPoint} from "parse";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-search-point',
    templateUrl: './search-point.component.html',
    styleUrls: ['./search-point.component.scss'],
    standalone: false
})
export class SearchPointComponent implements OnInit, OnDestroy {
    private centerEmit = new Subject<MarkerType>()
    public center$: Observable<MarkerType> = this.centerEmit.asObservable();
    private markersEmit = new Subject<MarkerType[]>();
    public markers$: Observable<MarkerType[] | undefined> = this.markersEmit.asObservable();
    public pointer$: Observable<MarkerType>;
    private form: FormGroup;
    public pointIsSet$: Observable<boolean>;
    private map: google.maps.Map | undefined;
    private subscriptions = new Subscription();

    constructor(public dialogRef: MatDialogRef<SearchPointComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { center: GeoPoint },
                private fb: FormBuilder) {
        this.centerEmit.next()
        this.subscriptions.add(
            this.center$.subscribe(center => {
                const size: google.maps.Size = new google.maps.Size(50, 50);
                const icon: google.maps.Icon = {
                    url: '/assets/icon/map/accurateIcon.svg',
                    scaledSize: size
                }
                center.icon = icon
                this.markersEmit.next([center]);
                setTimeout(() => {
                    this.markersEmit.next(undefined);
                }, 3000)
            })
        )

        this.form = this.fb.group({point: undefined});
        this.pointer$ = (this.form.get('point') as any).valueChanges.pipe(
            startWith(this.form.get('point')?.value),
            map(p => {
                return {location: p}
            })
        );
        this.pointIsSet$ = this.pointer$
            .pipe(
                startWith(this.form.get('point')?.value),
                map((p) => p != null)
            )
        if (this.data.center != null) {
            setTimeout(() => {
                const latLng = new google.maps.LatLng(this.data.center.latitude, this.data.center.longitude)
                this.form.get('point')?.setValue(latLng);
                this.centerEmit.next({location: latLng})
            })
        }
    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe()
    }

    closeDialog() {
        this.dialogRef.close(this.form.value)
    }

    setSearchAddress(event: { location: google.maps.LatLng } | undefined) {
        if (event != null) {
            setTimeout(() => {
                this.centerEmit.next({location: event.location})
            })
        }
    }

    dragEnd(event: google.maps.MapMouseEvent) {
        this.form.get('point')?.setValue(event.latLng);
    }

    mapReady(event: google.maps.Map) {
        this.map = event;
        this.setCursorAdd()
    }

    private setCursorAdd() {
        if (this.map != null) {
            this.map.setOptions({draggableCursor: 'url(/assets/icon/map/picket24.svg), auto'});
        }
    }

    clickMap(event: google.maps.MapMouseEvent | google.maps.IconMouseEvent) {
        if (event.latLng != null) {
            setTimeout(() => {
                this.form.get('point')?.setValue(event.latLng);
            })
        }
    }
}
